import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingWelcome } from './OnboardingWelcome';
import { OnboardingInstructions } from './OnboardingInstructions';
import { useOnboarding } from '../../hooks/useOnboarding';

type OnboardingStep = 'welcome' | 'instructions';

interface OnboardingFlowProps {
  onComplete: () => void;
}

export function OnboardingFlow({ onComplete }: OnboardingFlowProps) {
  const navigate = useNavigate();
  const [step, setStep] = useState<OnboardingStep>('welcome');
  const { completeOnboarding } = useOnboarding();

  const handleWelcomeContinue = useCallback(() => {
    setStep('instructions');
  }, []);

  const handleImportFile = useCallback(() => {
    completeOnboarding();
    onComplete();
    navigate('/importar');
  }, [completeOnboarding, onComplete, navigate]);

  return (
    <>
      {step === 'welcome' && (
        <OnboardingWelcome onContinue={handleWelcomeContinue} />
      )}
      {step === 'instructions' && (
        <OnboardingInstructions onImportFile={handleImportFile} />
      )}
    </>
  );
}
